/**
 * Mobile numbers are ten digits, entered without the country code.
 *
 * mobileDigits() is what a number field keeps as its value: digits only, never
 * more than ten. A number pasted with its country code or a leading 0
 * ("+91 98765 43210", "919876543210", "09876543210") is reduced to its ten digits.
 */
export const MOBILE_LENGTH = 10;

export function mobileDigits(value) {
  const raw = String(value || "").trim();
  let digits = raw.replace(/\D/g, "");
  if (raw.startsWith("+91")) digits = digits.slice(2);
  else if (raw.startsWith("0091")) digits = digits.slice(4);
  else if (digits.length === 12 && digits.startsWith("91")) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  return digits.slice(0, MOBILE_LENGTH);
}

export const isMobile = (digits) => /^[6-9]\d{9}$/.test(digits);
